import EmployeeSelect from '@/components/Form/Shared/EmployeeSelect'
import ProductGroupSelect from '@/components/Form/Shared/ProductGroupSelect'
import SubHeaders from '@/components/Headers/SubHeaders'
import { useFilterParams } from '@/hooks/useFilterParams'
import {
    CONTRACT_DIRECTION_OPTIONS,
    CONTRACT_ROLE_OPTIONS,
} from '@/modules/Contract/constants'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { FormItem, Tabs } from 'vnetwork-ui'
import Statistical from './Statistical'
import { tabs } from './tab'

const today = dayjs()

const formatDateRangeTitle = (value: unknown) => {
    if (!Array.isArray(value) || !value[0]) return ''
    const from = dayjs(value[0])
    const to = value[1] ? dayjs(value[1]) : null
    const fromText = from.isValid() ? from.format('DD/MM/YYYY') : ''
    const toText = to?.isValid() ? to.format('DD/MM/YYYY') : ''
    return toText ? `${fromText} - ${toText}` : fromText
}

const List = () => {
    const { t } = useTranslation()
    const { TabComponent, TabProps } = useTabs({ tabs })
    const { methods, encodedFilters } = useFilterParams('contracts.charts', {
        contract_id: undefined,
        contract_number_id: '',
        employee_id: [],
        contract_key: '',
        product_group_name: [],
        contract_role: [],
        contract_direction: [],
        created_at: [today.startOf('month'), today.endOf('month')],
    })
    const createdAtTitle = formatDateRangeTitle(methods.watch('created_at'))

    return (
        <div>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.customerContractList,
                        title: t('contract-list'),
                    },
                ]}
            />

            <div className="grid grid-cols-12 gap-2 mt-2">
                <FormItem
                    className="col-span-2"
                    name="contract_id"
                    type="number"
                    label={t('contract_id')}
                    control={methods.control}
                    placeholder={t('contract_id')}
                />
                <FormItem
                    className="col-span-2"
                    name="contract_number_id"
                    label={t('contract_number_id')}
                    type="textfield"
                    control={methods.control}
                    placeholder={t('contract_number_id')}
                />
                <FormItem
                    className="col-span-2"
                    name="contract_key"
                    type="textfield"
                    label={t('contract_key')}
                    control={methods.control}
                    placeholder={t('contract_key')}
                />
                <div className="col-span-2 bg-white">
                    <EmployeeSelect
                        multiple
                        showLabel={false}
                        name="employee_id"
                        control={methods.control}
                    />
                </div>
                <div className="col-span-2 bg-white">
                    <ProductGroupSelect
                        multiple
                        showLabel={false}
                        name="product_group_name"
                        control={methods.control}
                    />
                </div>
                <FormItem
                    className="col-span-2"
                    name="contract_role"
                    type="select"
                    multiple
                    options={CONTRACT_ROLE_OPTIONS(t)}
                    label={t('contract_role')}
                    control={methods.control}
                    placeholder={t('contract_role')}
                />
                <FormItem
                    className="col-span-2"
                    name="contract_direction"
                    type="select"
                    multiple
                    options={CONTRACT_DIRECTION_OPTIONS(t)}
                    label={t('contract_direction')}
                    control={methods.control}
                    placeholder={t('contract_direction')}
                />
                <div className="col-span-2 min-w-0" title={createdAtTitle}>
                    <FormItem
                        className="min-w-0 [&_[data-ui-component='TextField']]:w-full [&_.text-field-container]:w-full [&_.text-field-container]:min-w-0 [&_.text-field]:min-w-0 [&_.text-field]:pr-10 [&_.text-field]:overflow-hidden [&_.text-field]:text-ellipsis [&_.text-field]:whitespace-nowrap"
                        name="created_at"
                        type="daterangepicker"
                        control={methods.control}
                        placeholder={t('created_at')}
                    />
                </div>
            </div>
            <Statistical filters={encodedFilters} />
            <Tabs {...TabProps} />
            {TabComponent}
        </div>
    )
}

export default List
